import { makeStyles } from "@mui/styles";

const homeStyle = makeStyles((theme) => ({
  mainContainer: {
    padding: "65px 96px",
    backgroundColor: "#008374",
    overflow:"hidden",
    [theme.breakpoints.down(900)]: {
      padding: "55px 0px",
      textAlign: "center !important",
    },
  },

  gridContainer: {
    [theme.breakpoints.down(900)]: {
      flexDirection: "column-reverse !important",
    },
  },

  itemContainer:{
    paddingTop:"80px !important",
    [theme.breakpoints.down(900)]:{
    paddingTop:"56px !important", 
    }
  },

  mainHeading: {
    fontSize: "44px !important",
    [theme.breakpoints.down(1240)]: {
      fontSize: "36px !important",
    },
    fontWeight: "700 !important",
    color: "#fff",
  },
  para: {
    color: "rgba(255, 255, 255, 0.6)",
    fontWeight: "400 !important",
  },
  startButton: {
    "&.MuiButton-root": {
      padding: "15px 40px !important",
      borderRadius: "50px !important",
      boxShadow: " 0 0 15px rgb(0 0 0 / 8%) !important",
      background: " rgba(255, 255, 255, 0.1) !important",
      border: "2px solid rgba(255, 255, 255, 0.1) !important",
      letterSpacing: "1px !important",
      fontWeight: "500 !important",
      textTransform: "capitalize !important",
      fontSize: "15px",
      "&:hover": {
        borderColor: "rgba(255, 255, 255, 0.5) !important",
      },
    },
  },
}));

export default homeStyle;
